// AUTO-GENERATED — do not edit. Run `pnpm build` in packages/domain-data.
// Source: business/ishvaram/data/commerce/report_plans.snapshot.json

import type { PremiumReportPlanId, ReportDeliverables, ReportPerk } from "./reportPlans";

/** Bundle-light answer-continuation facts for interactive offer cards. */
export interface ReportPlanOfferDetails {
  id: PremiumReportPlanId;
  deliverables: ReportDeliverables;
  perks: ReportPerk[];
}

export const reportPlanOfferDetails: readonly ReportPlanOfferDetails[] = [
  {
    id: "brihat_kundali",
    deliverables: {
      sections: {
        en: "All 12 bhav, mahadasha + antardasha timeline, yogas & doshas",
        hi: "Saari 12 bhav, mahadasha + antardasha timeline, yoga aur dosha",
      },
      delivery: {
        en: "Private PDF + on-page reading, available after preparation",
        hi: "Private PDF aur on-page reading, taiyar hone ke baad uplabdh",
      },
      personalized: {
        en: "Upay matched to {{chart_reason}} in your chart",
        hi: "Aapki kundali ke {{chart_reason}} se matched upay",
      },
    },
    perks: [],
  },
  {
    id: "career_report",
    deliverables: {
      sections: {
        en: "10th house & D10 career chart, wealth yogas, best work windows",
        hi: "10th house aur D10 career chart, dhan yoga, best work windows",
      },
      delivery: {
        en: "28-page PDF + on-page reading, ready in 2 minutes",
        hi: "28-page PDF + on-page reading, 2 minute mein ready",
      },
      personalized: {
        en: "Dasha timeline read for {{chart_reason}} in your chart",
        hi: "Aapki kundali ke {{chart_reason}} ke liye dasha timeline",
      },
    },
    perks: [
      {
        id: "chat_credits",
        label: "Chat credits included",
        label_hi: "चैट क्रेडिट शामिल",
        kind: "entitlement",
        is_entitlement: true,
        icon: "💬",
        value: "5",
        display_order: 1,
      },
      {
        id: "free_followup",
        label: "1 free follow-up question",
        label_hi: "1 मुफ़्त फ़ॉलो-अप सवाल",
        kind: "entitlement",
        is_entitlement: true,
        icon: "↩️",
        value: "1",
        display_order: 2,
      },
      {
        id: "instant_delivery",
        label: "Instant PDF delivery",
        label_hi: "तुरंत PDF डिलीवरी",
        kind: "trust",
        is_entitlement: false,
        icon: "⚡",
        value: null,
        display_order: 3,
      },
      {
        id: "money_back",
        label: "7-day money-back guarantee",
        label_hi: "7-दिन मनी-बैक गारंटी",
        kind: "trust",
        is_entitlement: false,
        icon: "🛡️",
        value: null,
        display_order: 4,
      },
    ],
  },
  {
    id: "marriage_report",
    deliverables: {
      sections: {
        en: "7th house, Mangal Dosh, Kundali Milan, marriage-timing dasha",
        hi: "7th house, Mangal Dosh, Kundali Milan, shaadi-timing dasha",
      },
      delivery: {
        en: "10-page PDF + on-page reading, ready in 2 minutes",
        hi: "10-page PDF + on-page reading, 2 minute mein ready",
      },
      personalized: {
        en: "Compatibility & timing read for {{chart_reason}} in your chart",
        hi: "Aapki kundali ke {{chart_reason}} ka compatibility aur timing read",
      },
    },
    perks: [],
  },
  {
    id: "annual_forecast",
    deliverables: {
      sections: {
        en: "Month-by-month transits & dasha, caution and decision windows",
        hi: "Month-by-month transit aur dasha, caution aur decision windows",
      },
      delivery: {
        en: "Private PDF + on-page reading, available after preparation",
        hi: "Private PDF aur on-page reading, taiyar hone ke baad uplabdh",
      },
      personalized: {
        en: "12-month outlook read for {{chart_reason}} in your chart",
        hi: "Aapki kundali ke {{chart_reason}} ka 12-month outlook",
      },
    },
    perks: [],
  },
  {
    id: "muhurat_report",
    deliverables: {
      sections: {
        en: "Purpose-specific timing, avoid windows, sankalp & ritual checklist",
        hi: "Purpose-specific timing, avoid windows, sankalp aur ritual checklist",
      },
      delivery: {
        en: "17-page PDF + on-page reading, ready in 2 minutes",
        hi: "17-page PDF + on-page reading, 2 minute mein ready",
      },
      personalized: {
        en: "Shubh windows matched to {{chart_reason}} in your chart",
        hi: "Aapki kundali ke {{chart_reason}} se matched shubh windows",
      },
    },
    perks: [],
  },
  {
    id: "dosha_remedy_plan",
    deliverables: {
      sections: {
        en: "Dosha severity, cancellation checks, optional traditional practices",
        hi: "Dosha severity, cancellation check, optional traditional practices",
      },
      delivery: {
        en: "Private PDF + on-page reading, available after preparation",
        hi: "Private PDF aur on-page reading, taiyar hone ke baad uplabdh",
      },
      personalized: {
        en: "Available upay linked to {{chart_reason}} in your chart",
        hi: "Aapki kundali ke {{chart_reason}} se available upay",
      },
    },
    perks: [],
  },
  {
    id: "sade_sati",
    deliverables: {
      sections: {
        en: "Sade Sati phase, natal Shani, current dasha, pressure areas",
        hi: "Sade Sati phase, natal Shani, current dasha, pressure areas",
      },
      delivery: {
        en: "13-page PDF + on-page reading, ready in 2 minutes",
        hi: "13-page PDF + on-page reading, 2 minute mein ready",
      },
      personalized: {
        en: "Shani upay matched to {{chart_reason}} in your chart",
        hi: "Aapki kundali ke {{chart_reason}} se matched Shani upay",
      },
    },
    perks: [],
  },
  {
    id: "pitra_dosh",
    deliverables: {
      sections: {
        en: "9th house, Surya, Rahu/Ketu, cancellation, dasha activation",
        hi: "9th house, Surya, Rahu/Ketu, cancellation, dasha activation",
      },
      delivery: {
        en: "12-page PDF + on-page reading, ready in 2 minutes",
        hi: "12-page PDF + on-page reading, 2 minute mein ready",
      },
      personalized: {
        en: "Ancestral upay matched to {{chart_reason}} in your chart",
        hi: "Aapki kundali ke {{chart_reason}} se matched ancestral upay",
      },
    },
    perks: [],
  },
  {
    id: "mahadasha_forecast",
    deliverables: {
      sections: {
        en: "Current mahadasha & antardasha, next transition, month-level timing",
        hi: "Current mahadasha aur antardasha, next transition, month-level timing",
      },
      delivery: {
        en: "16-page PDF + on-page reading, ready in 2 minutes",
        hi: "16-page PDF + on-page reading, 2 minute mein ready",
      },
      personalized: {
        en: "Timing read for {{chart_reason}} in your chart",
        hi: "Aapki kundali ke {{chart_reason}} ka timing read",
      },
    },
    perks: [],
  },
  {
    id: "numerology_report",
    deliverables: {
      sections: {
        en: "Mulank & Bhagyank profile, name-number harmony, lucky numbers & days, year-ahead numerology",
        hi: "Mulank & Bhagyank profile, name-number harmony, lucky numbers & din, aane wale saal ka numerology",
      },
      delivery: {
        en: "10-page PDF + on-page reading, ready in 2 minutes",
        hi: "10-page PDF + on-page reading, 2 minute mein ready",
      },
      personalized: {
        en: "Numerology mapped to {{chart_reason}} in your birth details",
        hi: "Aapke janm vivaran ke {{chart_reason}} se mapped numerology",
      },
    },
    perks: [],
  },
  {
    id: "gemstone_report",
    deliverables: {
      sections: {
        en: "Weak & benefic grahas, recommended ratna, wearable rudraksha equivalent, dhaaran vidhi (metal, finger, day, mantra)",
        hi: "Kamzor & shubh graha, recommended ratna, pehne jaane wala rudraksha equivalent, dhaaran vidhi (dhatu, ungli, din, mantra)",
      },
      delivery: {
        en: "12-page PDF + on-page reading, ready in 2 minutes",
        hi: "12-page PDF + on-page reading, 2 minute mein ready",
      },
      personalized: {
        en: "Stone & rudraksha matched to {{chart_reason}} in your chart",
        hi: "Aapki kundali ke {{chart_reason}} se matched ratna aur rudraksha",
      },
    },
    perks: [],
  },
  {
    id: "baby_name_report",
    deliverables: {
      sections: {
        en: "Janma nakshatra & pada, auspicious starting syllables, 30+ curated names with meanings",
        hi: "Janma nakshatra & pada, shubh shuruaati akshar, 30+ chune hue naam arth ke saath",
      },
      delivery: {
        en: "12-page PDF + on-page reading, ready in 2 minutes",
        hi: "12-page PDF + on-page reading, 2 minute mein ready",
      },
      personalized: {
        en: "Name syllables derived from {{chart_reason}} in the child's chart",
        hi: "Bachche ki kundali ke {{chart_reason}} se nikale gaye naam akshar",
      },
    },
    perks: [],
  },
  {
    id: "lal_kitab_report",
    deliverables: {
      sections: {
        en: "Lal Kitab chart, ancestral debts (rin), blind & sleeping planets, low-cost totke & upay",
        hi: "Lal Kitab kundali, pitra rin, andhe & sote hue grah, saste totke & upay",
      },
      delivery: {
        en: "12-page PDF + on-page reading, ready in 2 minutes",
        hi: "12-page PDF + on-page reading, 2 minute mein ready",
      },
      personalized: {
        en: "Totke matched to {{chart_reason}} in your Lal Kitab chart",
        hi: "Aapki Lal Kitab kundali ke {{chart_reason}} se matched totke",
      },
    },
    perks: [],
  },
  {
    id: "transit_forecast",
    deliverables: {
      sections: {
        en: "Saturn & Jupiter gochar, key ingress dates, activated houses, 12-month timing map",
        hi: "Shani & Guru gochar, mukhya ingress dates, active houses, 12-mahine ka timing map",
      },
      delivery: {
        en: "14-page PDF + on-page reading, ready in 2 minutes",
        hi: "14-page PDF + on-page reading, 2 minute mein ready",
      },
      personalized: {
        en: "Transit timing mapped to {{chart_reason}} in your chart",
        hi: "Aapki kundali ke {{chart_reason}} se mapped transit timing",
      },
    },
    perks: [],
  },
  {
    id: "mahadasha_forecast_winback",
    deliverables: {
      sections: {
        en: "Current mahadasha & antardasha, next transition, month-level timing",
        hi: "Current mahadasha aur antardasha, next transition, month-level timing",
      },
      delivery: {
        en: "16-page PDF + on-page reading, ready in 2 minutes",
        hi: "16-page PDF + on-page reading, 2 minute mein ready",
      },
      personalized: {
        en: "Timing read for {{chart_reason}} in your chart",
        hi: "Aapki kundali ke {{chart_reason}} ka timing read",
      },
    },
    perks: [],
  },
  {
    id: "sade_sati_winback",
    deliverables: {
      sections: {
        en: "Sade Sati phase, natal Shani, current dasha, pressure areas",
        hi: "Sade Sati phase, natal Shani, current dasha, pressure areas",
      },
      delivery: {
        en: "13-page PDF + on-page reading, ready in 2 minutes",
        hi: "13-page PDF + on-page reading, 2 minute mein ready",
      },
      personalized: {
        en: "Shani upay matched to {{chart_reason}} in your chart",
        hi: "Aapki kundali ke {{chart_reason}} se matched Shani upay",
      },
    },
    perks: [],
  },
  {
    id: "ask_one_question",
    deliverables: {
      sections: {
        en: "Your one question, answered from your chart — the planetary cause + the upay",
        hi: "Aapka ek sawaal, kundali se answered — planetary cause + upay",
      },
      delivery: {
        en: "1-page PDF + on-page reading, ready in 2 minutes",
        hi: "1-page PDF + on-page reading, 2 minute mein ready",
      },
      personalized: {
        en: "A direct answer grounded in {{chart_reason}} in your chart",
        hi: "Aapki kundali ke {{chart_reason}} par grounded seedha jawaab",
      },
    },
    perks: [],
  },
] as const;

export const reportPlanOfferDetailsMap: Readonly<
  Record<PremiumReportPlanId, ReportPlanOfferDetails>
> = Object.fromEntries(reportPlanOfferDetails.map((plan) => [plan.id, plan])) as Record<
  PremiumReportPlanId,
  ReportPlanOfferDetails
>;
